import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { Pricing } from "@/components/Pricing";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const PAYPAL_OPTIONS = {
  clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: process.env.REACT_APP_PAYPAL_CURRENCY || "GBP",
  intent: "capture",
  components: "buttons",
  // honour live/sandbox toggle (the SDK auto-detects by clientId, but we keep
  // this explicit for clarity / fast debugging)
  "enable-funding": "paylater,venmo",
};

export default function PricingPage() {
  usePageMeta(
    "Pricing & Book Online",
    "Book USDD Academy classes, workshops, kids terms, online courses, coach qualifications and event entry. Secure card payments via Stripe or PayPal."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="Book Online"
          title="Pricing &"
          highlight="checkout."
          description="Pick a programme, pay securely, get a confirmation. Drop-ins, kids terms, online courses, coach qualifications and event entry — all bookable in one place. Pay with Card (Stripe) or PayPal."
          ctaPrimary={{ label: "Start Your Journey", to: "/journey" }}
          ctaSecondary={{ label: "Need help? Contact us", to: "/contact" }}
          bg={SITE.classImg3}
        />
        <section className="py-16 sm:py-24 bg-black">
          <div className="max-w-7xl mx-auto px-6 sm:px-8">
            {process.env.REACT_APP_PAYPAL_CLIENT_ID ? (
              <PayPalScriptProvider options={PAYPAL_OPTIONS} deferLoading={false}>
                <Pricing />
              </PayPalScriptProvider>
            ) : (
              <Pricing />
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
